export const REGISTRATION_INSTRUCTIONS = {
    ZUS: {
        keywords: ['zus'],
        config: {
            type: 'ZUS',
            appName: 'ZUS App',
            voucherName: { en: 'BUY1FREE1 CAKE VOUCHER', bm: 'BAUCAR KEK BELI 1 PERCUMA 1' },
            voucherImage: 'claim-voucher.png',
            appGuideImage: 'zus-app-guide.png',
            showBiometric: true,
            birthdayYear: '1970-2000',
            steps: [
                { label: { en: 'SELECT SMS', bm: 'PILIH SMS' }, value: '' },
                { label: { en: 'Name', bm: 'Nama' }, value: { en: 'Use Random Name or Your Name', bm: 'Gunakan Nama Rawak atau Nama Anda' } },
                { label: { en: 'Email', bm: 'E-mel' }, value: { en: 'Use (random)@gmail.com', bm: 'Gunakan (rawak)@gmail.com' } },
                { label: { en: 'Birthday', bm: 'Hari Jadi' }, value: { en: "Set TODAY'S DATE, Year 1970-2000 to receive BUY1FREE1 CAKE VOUCHER", bm: 'Tetapkan TARIKH HARI INI, Tahun 1990-2000 untuk terima BAUCAR BUY1FREE1' }, highlight: true },
                { label: { en: 'Referral', bm: 'Rujukan' }, value: { en: 'Please SKIP', bm: 'Sila LANGKAU' }, isWarning: true },
                { label: { en: 'Voucher', bm: 'Baucar' }, value: { en: 'Please CLAIM', bm: 'Sila TEBUS' }, isSuccess: true }
            ]
        }
    },
    TEALIVE: {
        keywords: ['tealive'],
        config: {
            type: 'TEALIVE',
            appName: 'Tealive App',
            voucherName: { en: 'Tealive Voucher', bm: 'Baucar Tealive' },
            voucherImage: null,
            appGuideImage: null,
            showBiometric: false,
            birthdayYear: '1990-2000',
            steps: [
                { label: { en: 'SELECT SMS', bm: 'PILIH SMS' }, value: '' },
                { label: { en: 'Name', bm: 'Nama' }, value: { en: 'Use Random Name or Your Name', bm: 'Gunakan Nama Rawak atau Nama Anda' } },
                { label: { en: 'Email', bm: 'E-mel' }, value: { en: 'Use (random)@gmail.com', bm: 'Gunakan (rawak)@gmail.com' } },
                { label: { en: 'Birthday', bm: 'Hari Jadi' }, value: { en: "Set TODAY'S DATE, Year 1990-2000", bm: 'Tetapkan TARIKH HARI INI, Tahun 1990-2000' } },
                { label: { en: 'Referral', bm: 'Rujukan' }, value: { en: 'Please SKIP', bm: 'Sila LANGKAU' }, isWarning: true },
                { label: { en: 'Voucher', bm: 'Baucar' }, value: { en: 'Please CLAIM', bm: 'Sila TEBUS' }, isSuccess: true }
            ]
        }
    },
    DEFAULT: {
        config: {
            type: 'DEFAULT',
            appName: 'App',
            voucherName: { en: 'Voucher', bm: 'Baucar' },
            voucherImage: null,
            appGuideImage: null,
            showBiometric: false,
            birthdayYear: '1990-2000',
            steps: [
                { label: { en: 'SELECT SMS', bm: 'PILIH SMS' }, value: '' },
                { label: { en: 'Name', bm: 'Nama' }, value: { en: 'Use Random Name or Your Name', bm: 'Gunakan Nama Rawak atau Nama Anda' } },
                { label: { en: 'Email', bm: 'E-mel' }, value: { en: 'Use (random)@gmail.com', bm: 'Gunakan (rawak)@gmail.com' } },
                { label: { en: 'Birthday', bm: 'Hari Jadi' }, value: { en: "Set TODAY'S DATE, Year 1990-2000", bm: 'Tetapkan TARIKH HARI INI, Tahun 1990-2000' } },
                { label: { en: 'Referral', bm: 'Rujukan' }, value: { en: 'Please SKIP', bm: 'Sila LANGKAU' }, isWarning: true },
                { label: { en: 'Voucher', bm: 'Baucar' }, value: { en: 'Please CLAIM', bm: 'Sila TEBUS' }, isSuccess: true }
            ]
        }
    }
};

// Helper function to get instruction config based on products
export const getInstructionConfig = (products) => {
    const productNames = products?.map(p => (p.productName || p.itemName || '').toLowerCase()) || [];

    // Check for ZUS
    const hasZus = productNames.some(n => REGISTRATION_INSTRUCTIONS.ZUS.keywords.some(k => n.includes(k)));
    if (hasZus) return REGISTRATION_INSTRUCTIONS.ZUS.config;

    // Check for Tealive
    const hasTealive = productNames.some(n => REGISTRATION_INSTRUCTIONS.TEALIVE.keywords.some(k => n.includes(k)));
    if (hasTealive) return REGISTRATION_INSTRUCTIONS.TEALIVE.config;

    // Default
    return REGISTRATION_INSTRUCTIONS.DEFAULT.config;
};
